import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import { useNavigate } from 'react-router-dom';
import { getBlob, getData, patchData, Postdata, updateData } from '../../../API/GlobalApi.js';
import exporticon from '../../../assets/icons/export-data.svg';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import SearchingBar from '../../../Utils/Searching.js';
import { handlePaginate } from '../../../Utils/handlePagination.js';
import Notifier from '../../../Utils/notify.js';
import { formatDateDDMMYYYYHHMMSS, formatDateDDMMYYYYHHMMSS_UTC } from '../../../Utils/data&dateTime.js';
import Select from 'react-select';
import { reactSelectStyles } from '../../../Utils/selectBoxStyle.js';
import { highlightMatch } from '../../../Utils/highlightSearchFunctions.js';

export const OnlinePaymentReportDashboard = () => {


  const [dnparentdata, setdnparentdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedOrgDetails, setSelectedOrgDetails] = useState([]);
  const [parentorgid, setparentorgid] = useState(null);
  const [filterQueryString, setFilterQueryString] = useState(() => {
    const today = new Date().toISOString().split("T")[0];
    return {
      start_date: today,
      end_date: today,
    };
  });

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const [totalCount, setTotalCount] = useState(0);
  const [isSearchLoading, setSearchLoading] = useState(false);
  const pageSize = 10;
  const pageCounts = Math.ceil(totalCount / pageSize);
  const todayDate = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(todayDate);
  const [endDate, setEndDate] = useState(todayDate);
  const [filterData, setfilterData] = useState([])
  const [filterLoading, setFilterLoading] = useState(false);

  const skipSpinnerRef = useRef(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const getorgdata = async () => {

    // ✅ Build query params safely
    const params = new URLSearchParams();
    // if (startDate) params.set("start_date", startDate);
    // if (endDate) params.set("end_date", endDate);

    // // ✅ Append other filters if exist
    // if (filterQueryString) {
    //   const extraParams = new URLSearchParams(filterQueryString);
    //   extraParams.forEach((value, key) => params.set(key, value));
    // }

    if (filterQueryString) {
      Object.entries(filterQueryString).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, value);
        }
      });
    }



    const finalUrl = `students/get-student-payments/?${params.toString()}`;
    if (!skipSpinnerRef.current) {
      if (isInitialLoad) setIsLoading(true);
      else setSearchLoading(true);
    }
    try {
      const response = await getData(finalUrl);

      const data = Array.isArray(response) ? response : response?.results || [];
      setdnparentdata(data);
      setfilterData(data);
      setSelectedOrgDetails(data[0] || null);
      setTotalCount(response?.count || data.length);
    } catch (err) {
      setdnparentdata([]);
      setSelectedOrgDetails(null);
      Notifier.error("Failed to fetch data. Please try again later.");
    } finally {
      if (!skipSpinnerRef.current) {
        if (isInitialLoad) {
          setIsLoading(false);
          setIsInitialLoad(false);
        } else {
          setSearchLoading(false);
        }
      }
      skipSpinnerRef.current = false;
    }
  };




  useEffect(() => {

    getorgdata();

  }, [currentPage, filterQueryString]);


  const handleRowClick = (orgId, row) => {
    let selectedOrg = null;
    if (row.original.id === orgId) {
      selectedOrg = row.original;
    }
    if (selectedOrg) {
      const { id, name, parent, email } = selectedOrg;
      setSelectedOrgDetails(selectedOrg);
      // getdeptdata(id);
      setparentorgid(id);
      // localStorage.setItem('selectedOrgDetails', JSON.stringify({ id, name, parent, email }));
    } else {
      Notifier.error("Details not found");
    }
  };


  const handleExportExcel = async () => {
    try {
      let finalQuery = filterQueryString;


      if (!filterQueryString) {
        if (!startDate || !endDate) {
          Notifier.error('❌ Please select both Start and End dates.');
          return;
        }
        finalQuery = `start_date=${startDate}&end_date=${endDate}`;
      }

      const urlWithParams = `students/export-student-payments-to-xls/?${finalQuery}`;

      const blob = await getBlob(urlWithParams);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'students_export.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      Notifier.error('❌ Excel export failed');
    }
  };


  const sourceData = useMemo(() => {
    return filterQueryString ? filterData : dnparentdata;
  }, [dnparentdata, filterData, filterQueryString]);


  const formattedData = useMemo(() => {
    return sourceData?.map((org) => ({
      id: org.payment_id,
      student_name: org.student_name,
      primary_contact_number: org.primary_contact_number,
      payment_type: org.payment_type,
      mode_of_payment: org.mode_of_payment,
      payment_transaction_number: org.payment_transaction_number,
      easepayid: org.easepayid,
      payment_date: org.payment_date,
      payment_status: org.payment_status,
      amount: org.amount,
      course_name: org.course_name,
      provisional_registration_number: org.provisional_registration_number,
      provisional_admission_date: org.provisional_admission_date,
      permanent_registration_number: org.permanent_registration_number,
      permanent_admission_date: org.permanent_admission_date,
      handleRowClick: handleRowClick

    }));
  }, [sourceData, handleRowClick]);

  const paginatedData = useMemo(() => {
    const start = currentPage * pageSize;
    return formattedData.slice(start, start + pageSize);
  }, [formattedData, currentPage, pageSize]);



  const searchValue = new URLSearchParams(filterQueryString).get("search") || "";

  const totalAmount = useMemo(() => {

    return filterData.reduce((sum, item) => {
      if (item.payment_status?.toLowerCase() === "success") {
        return sum + (parseFloat(item.amount) || 0);
      }
      return sum;
    }, 0);
  }, [filterData]);

  const columns = useMemo(
    () => [

      {
        Header: 'Pay Date & Time',
        accessor: 'payment_date',
        disableSortBy: true,
        Cell: ({ row }) => {
          const rawDate = row.original.payment_date;
          const formatted = rawDate
            ? new Intl.DateTimeFormat('en-IN', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            }).format(new Date(rawDate))
            : 'N/A';
          return (
            <div style={{ cursor: 'pointer', height: "100%", display: 'flex', alignItems: 'center' }}>
              <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                {formatDateDDMMYYYYHHMMSS_UTC(rawDate)}
              </p>
            </div>
          );
        }
      },


      {
        Header: 'Student Name',
        accessor: 'student_name',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div >

            {/* <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.student_name}</p> */}
            <p className="no-text-cursor"
              style={{
                textAlign: "left",
                color: "#222F3E",
                fontWeight: 500,
                margin: 0,
              }}
              dangerouslySetInnerHTML={{
                __html: highlightMatch(
                  row.original.student_name?.toString() || "-",
                  searchValue
                ),
              }}
            />
          </div>
        )
      },
      {
        Header: 'Reg. Ph. no.',
        accessor: 'primary_contact_number',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="no-text-cursor">
            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.primary_contact_number}</p>
          </div>
        ),
      },
      {
        Header: 'Course Name',
        accessor: 'course_name',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="no-text-cursor">
            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.course_name}</p>
          </div>
        )
      },
      {
        Header: 'Fee Type',
        accessor: 'payment_type',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="no-text-cursor">
            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.payment_type}</p>
          </div>
        )
      },
      {
        Header: 'Payment Details',
        accessor: 'mode_of_payment',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="no-text-cursor" >
            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}><span style={{ fontWeight: '700' }}>MP -</span> ({row.original.mode_of_payment})</p>
            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}><span style={{ fontWeight: '700' }}>Tn No -</span> {row.original.payment_transaction_number}</p>
            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}><span style={{ fontWeight: '700' }}>Ezs Id -</span> {row.original.easepayid}</p>
          </div>
        )
      },

      {
        Header: 'Amount',
        accessor: 'amount',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="no-text-cursor">
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.amount}</p>
          </div>
        )
      },
      {
        Header: 'Payment Status',
        accessor: 'payment_status',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="no-text-cursor">
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.payment_status}</p>
          </div>
        )
      },
      {
        Header: 'Pro Ad Details',
        accessor: 'provisional_admission_date',
        disableSortBy: true,
        Cell: ({ row }) => {
          const formatDate = (dateStr) => {
            if (!dateStr) return 'N/A';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
          };
          return (
            <div className="no-text-cursor">
              <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.provisional_registration_number}</p>
              <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 600, fontSize: '10px', margin: 0 }}>
                ({formatDate(row.original.provisional_admission_date)})
              </p>
            </div>
          );
        }
      },
      {
        Header: 'Reg. Details',
        accessor: 'permanent_admission_date',
        disableSortBy: true,
        Cell: ({ row }) => {
          const formatDate = (dateStr) => {
            if (!dateStr) return 'N/A';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
          };
          return (
            <div className="no-text-cursor">
              <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.permanent_registration_number}</p>
              <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 600, fontSize: '10px', margin: 0 }}>
                ({formatDate(row.original.permanent_admission_date)})
              </p>
            </div>
          );
        }
      }

    ],
    []
  );







  const handleSetSearchResults = (data) => {

    setfilterData(Array.isArray(data) ? data : []);
  };

  // const handlePageChange = ({ selected }) => {
  //   setCurrentPage(selected);
  //   handlePaginate({
  //     selectedPage: selected,
  //     url: 'students/get-student-payments/',
  //     filterQueryString,
  //     setResults: handleSetSearchResults,
  //     setTotalCount,
  //     setFilterQueryString,
  //   });
  // }

  const searchInputRef = useRef(null);

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);


  const paymentModeOptions = [
    { value: "online", label: "Online" },
    { value: "offlinne", label: "Offline" },

  ];



  return (

    <>
      {isLoading ? (
        <TableSkeleton rows={10} columns={6} showHeader={true} />
      ) :
        (
          <div style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflow: "hidden",
            position: "relative",
          }}>

            {/* ── FIXED: Title + Search + Filters ── */}
            {/* ── FIXED: Title + Search + Filters ── */}
            <div style={{ flexShrink: 0, padding: "8px 12px" }}>

              {/* Row 1: Title */}
              <div className="row">
                <div className="col-md-12">
                  <h2 className="main-heading">Accounts</h2>
                </div>
              </div>

              {/* Row 2: Payments + Total | Search + Dates + Export */}
              <div className="row align-items-center">

                {/* col-4: Payments count + Total spaced between */}
                <div className="col-md-4 d-flex justify-content-between align-items-center">
                  <h4 className="text-primary mb-0">Payments ({dnparentdata?.length})</h4>
                  <span style={{ fontSize: "15px", fontWeight: 600 }}>Total: ₹{totalAmount}</span>
                </div>

                {/* col-8: Search + Dates + Export */}
                <div className="col-md-8">
                  <div style={{ display: "flex", gap: "10px", alignItems: "flex-end", justifyContent: "flex-end" }}>
                    <div style={{ width: "300px" }}>
                      <SearchingBar
                        placeholder="Search by name, mobile no, reg. no…"
                        url="students/get-student-payments/"
                        filterQueryString={filterQueryString}
                        setResults={handleSetSearchResults}
                        ref={searchInputRef}
                        setTotalCount={setTotalCount}
                        setFilterQueryString={setFilterQueryString}
                        setSearchLoading={setSearchLoading}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                    <div>
                      <label className="form-labell">Start Date</label>
                      <input
                        type="date"
                        value={filterQueryString?.start_date || ""}
                        onChange={(e) => setFilterQueryString(prev => ({ ...(prev || {}), start_date: e.target.value || undefined }))}
                        className="form-control"
                        style={{ height: "46px" }}
                      />
                    </div>
                    <div>
                      <label className="form-labell">End Date</label>
                      <input
                        type="date"
                        value={filterQueryString?.end_date || ""}
                        onChange={(e) => setFilterQueryString(prev => ({ ...(prev || {}), end_date: e.target.value || undefined }))}
                        className="form-control"
                        style={{ height: "46px" }}
                        max={getTodayDate()}
                      />
                    </div>
                    <button
                      className="filter-btn"
                      style={{ background: "white", border: "1px solid black", height: "43px" }}
                      onClick={handleExportExcel}
                      title="Export Report"
                    >
                      <img src={exporticon} alt="export" />
                    </button>
                  </div>
                </div>

              </div>
            </div>



            {/* ── SCROLLABLE: Table only ── */}
            <div style={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              padding: "0 12px",
              position: "relative",
            }}>
              {isSearchLoading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                  <TableSkeleton />
                </div>
              ) : formattedData?.length > 0 ? (
                <AdvanceTable
                  key={currentPage}
                  columns={columns}
                  pageCounts={Math.ceil(formattedData.length / pageSize)}
                  handlePageChange={({ selected }) => setCurrentPage(selected)}
                  selectedData={selectedOrgDetails}
                  data={paginatedData}
                  handleRowClick={handleRowClick}
                  currentPage={currentPage}
                  checkbox={false}
                  showPagination={true}
                />
              ) : (!isLoading && (
                <div style={{
                  display: "flex", flexDirection: "column",
                  alignItems: "center", justifyContent: "center",
                  flex: 1, color: "#888", textAlign: "center",
                }}>
                  No Payment Details.
                </div>
              ))}
            </div>
          </div>
        )}
      <div>
      </div>


    </>
  );
};

